import React from 'react';
import {
  Box,
  SpaceBetween,
  Header,
  Button,
  Badge,
} from '@cloudscape-design/components';

function ProductCard({ 
  title, 
  vendor, 
  logo, 
  category, 
  description, 
  isNew = false,
  href,
  buttonText = "Learn More"
}) {
  return (
    <Box padding="l" variant="container">
      <SpaceBetween size="m">
        <div>
          <img 
            src={logo} 
            alt={`${title} logo`} 
            style={{ width: '80px', height: '80px', borderRadius: '8px' }}
          />
        </div>
        
        <div style={{ textAlign: 'left' }}>
          <SpaceBetween size="xxs">
            <div style={{ display: 'flex', alignItems: 'left', justifyContent: 'center', gap: '8px' }}>
              <Header variant="h3">{title}</Header>
              {isNew && <Badge color="green">New</Badge>}
            </div>
            <Box variant="small" color="text-body-secondary">{vendor}</Box>
          </SpaceBetween>
        </div>
        
        <Box variant="small" color="text-body-secondary">
          {category}
        </Box>
        
        <Box variant="p">
          {description}
        </Box>
        
        <Button 
          variant="primary" 
          iconName="external"
          href={href}
          target="_blank"
        >
          {buttonText}
        </Button>
      </SpaceBetween>
    </Box>
  );
}

export default ProductCard;
